// @ts-nocheck
import React from "react";
import { useSelector } from "react-redux";

const FeedSkeletonCard = () => {
  const isDark = useSelector((data) => data.appState.appTheme) === "#0b1118";

  return (
    <div
      className="surface-card news-card"
      aria-hidden="true"
      style={{
        overflow: "hidden",
        borderRadius: 24,
        background: isDark ? "rgba(17, 25, 39, 0.84)" : "rgba(255, 255, 255, 0.9)",
      }}
    >
      <div style={{ padding: "1rem", display: "grid", gap: "0.8rem" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <div className="premium-skeleton-shimmer" style={{ width: 38, height: 38, borderRadius: 999 }} />
          <div style={{ flex: 1, display: "grid", gap: 8 }}>
            <div className="premium-skeleton-shimmer" style={{ width: "36%", height: 10, borderRadius: 999 }} />
            <div className="premium-skeleton-shimmer" style={{ width: "58%", height: 14, borderRadius: 999 }} />
          </div>
        </div>
        <div className="premium-skeleton-shimmer" style={{ width: "100%", height: 16, borderRadius: 999 }} />
        <div className="premium-skeleton-shimmer" style={{ width: "78%", height: 16, borderRadius: 999 }} />
      </div>
      <div className="premium-skeleton-shimmer" style={{ width: "100%", aspectRatio: "16 / 10" }} />
      <div style={{ padding: "1rem", display: "grid", gap: 10 }}>
        <div className="premium-skeleton-shimmer" style={{ width: "92%", height: 12, borderRadius: 999 }} />
        <div className="premium-skeleton-shimmer" style={{ width: "76%", height: 12, borderRadius: 999 }} />
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          <div className="premium-skeleton-shimmer" style={{ width: 84, height: 24, borderRadius: 999 }} />
          <div className="premium-skeleton-shimmer" style={{ width: 92, height: 24, borderRadius: 999 }} />
        </div>
      </div>
    </div>
  );
};

const NewsSkeleton = ({ count = 6 }) => {
  return (
    <div className="news-grid" style={{ minHeight: 380 }}>
      {Array.from({ length: count }, (_, index) => (
        <FeedSkeletonCard key={index} />
      ))}
    </div>
  );
};

export default NewsSkeleton;
